import React from "react";
import {
  FormFieldSet,
  InfoCardNew,
  InfoCardNewAdv,
  InfoWrapper,
  NewTab,
  NewTabPill,
} from "../../../../components";
import ItModule from "./IncentiveModule/ItModule";
import NonItModule from "./IncentiveModule/NonItModule";
import BenchModule from "./IncentiveModule/BenchModule";

const IncentiveModule = () => {
  const IncentiveMenus = React.useMemo(
    () => [
      {
        title: "IT",
        page: <ItModule />,
        type: "main",
      },
      {
        title: "Non-IT",
        page: <NonItModule />,
        type: "main",
      },
      {
        title: "Benchsale",
        page: <BenchModule />,
        type: "main",
      },
    ],
    [],
  );

  const incentiveInfo = [
    { title: "IT", value: 450, backValue: 400 },
    { title: "Non-IT", value: 460, backValue: 400 },
    { title: "Benchsale", value: 380, backValue: 400 },
    { title: "Total", value: 1290, backValue: 1200 },
  ];

  return (
    <div className="flex-1 w-full flex flex-col gap-2 overflow-auto">
      <div className="w-full flex justify-end mt-1">
        <div className="w-full max-w-[230px]">
          <FormFieldSet
            title="Date Range"
            noTitle
            size="sm"
            placeholder="Select Date Range"
            type="monthpicker"
          />
        </div>
      </div>

      <InfoWrapper className="min-w-60!">
        {incentiveInfo.map((item, index) => (
          <InfoCardNewAdv
            key={index}
            title={item.title}
            value={item.value}
            prefix="$"
            backValue={item.backValue}
            bgConfig={{ className: "rounded-xl" }}
          />
        ))}
        </InfoWrapper>
      

      <div className="flex-1 overflow-hidden flex">
        <NewTabPill
          tabs={IncentiveMenus}
          color="black"
          variant="outlined"
          mode="url"
          tabId="incentive-management"
        />
      </div>
    </div>
  );
};

export default IncentiveModule;
